import { types, type Instance } from 'mobx-state-tree';

// The list of builtin data types
export const BUILTIN_DATA_TYPES: string[] = [
  'Boolean',
  'Character',
  // Date/Time used to be DateTime in an earlier (buggy) version of the tool.
  // Because of that we need to preprocess the snapshot of an attribute to keep
  // supporting models that were saved with that early version. See
  // 'preProcessSnapshot' in './attribute.js'.
  'Date/Time',
  'Float',
  'Integer',
  'Long text',
  'String',
];

/**
 * A MERODE data type
 */
const DataType = types
  .model('DataType', {
    id: types.identifier,
    name: types.string,
  })
  .actions(self => ({
    setName(name: string) {
      self.name = name;
    },
  }));

export type IDataType = Instance<typeof DataType>;

export default DataType;
